import type { FC, ReactNode } from 'react'
import type { PersonSummary } from '@/types'

import { cn } from '@/lib/utils'

interface LifeDatesProps {
    person: Pick<PersonSummary, 'id' | 'born' | 'died'>
    className?: string
}

/** Shows the stored born and died values exactly as written, each inline-editable on its own. */
const LifeDates: FC<LifeDatesProps> = ({ person, className }): ReactNode => {
    if (!person.born && !person.died) return null

    return (
        <span className={cn('block text-sm text-umber', className)}>
            {person.born && !person.died && 'Born '}
            {!person.born && person.died && 'Died '}

            {person.born && (
                <span data-mdlfy-cms={`people:${person.id}:born`}>
                    {person.born}
                </span>
            )}

            {person.born && person.died && (
                <>
                    <span aria-hidden='true'> – </span>
                    <span className='sr-only'> to </span>
                </>
            )}

            {person.died && (
                <span data-mdlfy-cms={`people:${person.id}:died`}>
                    {person.died}
                </span>
            )}
        </span>
    )
}

export default LifeDates
